<template>
  <v-dialog max-width="450" @click:outside="closeModal">
    <v-card class="rounded-lg relative">
      <i
        class="mdi mdi-close absolute top-3 right-3 text-2xl cursor-pointer"
        @click="closeModal"
        id="modal_icon_click_close"
      ></i>
      <div
        class="w-full bg-white flex flex-col items-center justify-center p-5"
      >
        <div
          class="h-20 w-20 border-b-4 flex items-center justify-center rounded-full"
          :class="{ 'border-green-300': status, 'border-red-300': !status }"
        >
          <span class="text-green-600 text-2xl font-extrabold" v-if="status">✓</span>
          <span class="text-red-600 text-4xl font-bold" v-else>×</span>
        </div>
        <p class="font-normal text-base mt-5 mb-5">
          {{ message }}
        </p>
        <div class="w-full flex items-end justify-center">
          <div class="p-1">
            <button
              @click="closeModal"
              type="button"
              class="bg-red-500 text-white text-sm py-2 px-15 rounded border border-gray-500"
              id="modal_btn_click_close"
            >
              Tutup
            </button>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Notification",
  props: {
    status: Boolean,
    message: String,
    visible: Boolean,
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>
